var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import dayjs from 'dayjs';
import { GetCollaboratorsApi } from '../../apis/get-collaborators-api';
import { TransformCollaborator } from '../../utils/transform-collaborator.interface';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
let GetCollaboratorsRepositoryImpl = class GetCollaboratorsRepositoryImpl {
    constructor(_getCollaboratorsApi, _transformCollaborator) {
        this._getCollaboratorsApi = _getCollaboratorsApi;
        this._transformCollaborator = _transformCollaborator;
    }
    async getCollaborators(spaceId, folderId) {
        const collaborators = await this._getCollaboratorsApi.getCollaborators({
            space_id: spaceId,
            folder_id: folderId,
        });
        return this._transformCollaboratorRoles(collaborators);
    }
    _transformCollaboratorRoles(collaborators) {
        return collaborators.map(collaborator => {
            return this._transformCollaborator.transform(collaborator);
        });
    }
};
GetCollaboratorsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(GetCollaboratorsApi)),
    __param(1, inject(TransformCollaborator)),
    __metadata("design:paramtypes", [typeof (_a = typeof GetCollaboratorsApi !== "undefined" && GetCollaboratorsApi) === "function" ? _a : Object, typeof (_b = typeof TransformCollaborator !== "undefined" && TransformCollaborator) === "function" ? _b : Object])
], GetCollaboratorsRepositoryImpl);
export { GetCollaboratorsRepositoryImpl };
